import React from "react";
import ProfileFeedbackUpload from "./_ProfileFeedbackUpload";

class ProfileFeedbackForm extends React.Component {
  state = {
    senderEmail: this.props.User.email,
    message: "",
    subject: "",
    files: [],
    category: "",
  };

  onChanged = ({ target }) => {
    this.setState({ [target.name]: target.value });
  };

  mergeFiles = (fileArr) => {
    const { files } = this.state;
    this.setState({ files: [...files, ...fileArr] });
  };

  render() {
    const { User, _ } = this.props;
    const { senderEmail, message, subject, category } = this.state;

    return (
      <div className="contact-us-els">
        <div className="profile-sidebar-form">
          <div className="omni-form-group-message">
            <div className="form-row pb-3">
              <label className="required-input pb-2">{_.EmailAddress} </label>
              <input
                value={User.email}
                name="email"
                type="text"
                disabled
                required={true}
              />
            </div>
            <div className="form-row pb-3">
              <label className="required-input pb-2">{_.Subject} </label>
              <input
                name="subject"
                label={_.Subject + " *"}
                type="text"
                value={subject}
                required={true}
                onChange={this.onChanged}
              />
            </div>

            <div className="form-row pb-3">
              <label className="pb-2">{_.AttachFile}</label>

              <div className="upload-section">
                <ProfileFeedbackUpload
                  onFileSelectSuccess={(files) => this.mergeFiles(files)}
                  onFileSelectError={({ error }) => alert(error)}
                ></ProfileFeedbackUpload>

                <div className="file-name">
                  {this.state.files.map((item) => (
                    <p>{item.name}</p>
                  ))}
                </div>
              </div>
            </div>

            <div className="form-row pb-3">
              <select
                name="category"
                value={category}
                onChange={this.onChanged}
              >
                <option value="">{_.SelectCategory}</option>
                <option>{_.SelectOptions.ProductSupport}</option>
                <option>{_.SelectOptions.GeneralEnquiry}</option>
                <option>{_.SelectOptions.SuggestedImprovements}</option>
              </select>
            </div>

            <div className="form-row textarea">
              <textarea
                name="message"
                label={_.Message}
                placeholder="Message"
                value={message}
                type="textarea"
                onChange={this.onChanged}
              />
            </div>
          </div>
        </div>

        <div className="change-password-action">
          <button
            className="btn btn-primary"
            disabled={!(senderEmail && message && subject)}
            onClick={(e) => {
              e.preventDefault();
              this.props.SendFeedBack(
                this.state.subject,
                this.state.message,
                this.state.senderEmail,
                this.state.category,
                this.state.files
              );
              this.props.setFeedbackDone(true);
            }}
          >
            {_.Submit}
          </button>
        </div>
      </div>
    );
  }
}

export default ProfileFeedbackForm;
